import { render, staticRenderFns } from "./AuthRoot.vue?vue&type=template&id=c534c818&"
import script from "./AuthRoot.vue?vue&type=script&lang=ts&"
export * from "./AuthRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports